import React from "react";
import { Link } from "react-router-dom";
import { Button, Typography, Popover, List, ListItem } from "@material-ui/core";
import useStyles from "./styles";

const tabs = [
  { name: "Dashboard", link: "/" },
  {
    name: "Study",
    children: [
      { name: "Solo Study", link: "/solo-study" },
      { name: "Group Study", link: "/group-study" },
    ],
  },
  { name: "Explore", link: "/explore" },
];

const NavItems = () => {
  const classes = useStyles();
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const openMenu = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  const closeMenu = () => {
    setMenuAnchor(null);
  };
  const SubNav = ({ tab }) => (
    <Popover
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={closeMenu}
    >
      <List className={classes.list}>
        {tab.children.map((child, index) => (
          <ListItem key={index} button>
            <Link
              className={classes.subnavText}
              to={child.link}
              onClick={closeMenu}
            >
              <Typography style={{ fontWeight: "bold" }}>
                {child.name}
              </Typography>
            </Link>
          </ListItem>
        ))}
      </List>
    </Popover>
  );

  return tabs.map((tab, index) =>
    tab.children ? (
      <div key={index}>
        <Button className={classes.navText} onClick={openMenu}>
          {tab.name}
        </Button>
        <SubNav tab={tab} />
      </div>
    ) : (
      <Button key={index}>
        <Link to={tab.link} className={classes.navText}>
          <Typography style={{ fontWeight: "bold" }}>{tab.name}</Typography>
        </Link>
      </Button>
    )
  );
};

export default NavItems;
